import { Horizontal, Texto, Vertical, addCommasToNumber } from '@gravitate-js/excalibrr'
import { useMemo } from 'react'

export const Products = ({ data }) => {
  const productColors = [
    'hsl(215, 84%, 71%)',
    'hsl(214, 84%, 45%)',
    'hsl(260, 52%, 81%)',
    'hsl(254, 45%, 55%)',
    'hsl(207, 32%, 66%)',
  ]
  const normalizedProducts = useMemo(() => {
    if (!data?.products) return []
    // need to aggregate the products
    const productMap = {}
    data.products.forEach((product) => {
      if (productMap[product.product_name]) {
        productMap[product.product_name].quantity += product.quantity
      } else {
        productMap[product.product_name] = product
      }
    })

    return Object.values(productMap)
  }, [data])
  return (
    <Vertical className={'full-height-width'} alignItems={'start'} justifyContent={'start'}>
      {normalizedProducts?.map((product, index) => {
        return (
          <Horizontal
            justifyContent={'space-between'}
            key={`${index}`}
            verticalCenter
            className={'p-2 full-height-width'}
          >
            <Texto weight={'bold'} className={'text-truncate mr-2'} textTransform={'uppercase'}>
              {product.product_name}
            </Texto>
            <Horizontal verticalCenter>
              <div
                className={'m-2'}
                style={{
                  borderRadius: '50%',
                  backgroundColor: productColors[index],
                  height: '7px',
                  width: '7px',
                }}
              />
              <Texto className={'text-truncate'}>{addCommasToNumber(product.quantity, 0)}</Texto>
            </Horizontal>
          </Horizontal>
        )
      })}
    </Vertical>
  )
}
